import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import { signoutUser } from '../actions/index';
import Colors from '../styles/colors';
import PartnerBanner from './PartnerBanner';
import { STATIC_HOMEPAGE_URL } from '../config';
import { canUserAccessFeature } from '../helpers/userinfoHelper';
import { authManager } from '../helpers/managers';
const { isFreeAccount } = require('../../server/scripts/utils.js')();

const publicPathnames = ['/soundcast_checkout', '/soundcast_checkout2'];

class _SoundwiseHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonValue: 0,
    };
    this.signoutUser = this.signoutUser.bind(this);
    this.handleButtonChange = this.handleButtonChange.bind(this);
  }

  signoutUser() {
    authManager.signOut()
      .then(
        () => {
          this.props.signoutUser(false); // false --> disable of autoredirect to /signin

          const locationPathname = window && window.location && (window.location.pathname || '');
          if (publicPathnames.includes(locationPathname.toLocaleLowerCase())
            && window && window.location
          ) {
            window.location.reload();
          } else {
            this.props.history.push('/signin');
          }
        },
        error => {
          console.error('Sign Out Error', error);
        }
      );
  }

  capFirstLetter(name) {
    if (isUndefined(name)) {
      return 'User';
    }

    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  handleButtonChange(e, value) {
    this.setState({
      buttonValue: Number(value),
    });
    if (Number(value) == 1) {
      this.signoutUser();
    }
  }

  renderLogin() {
    const { isLoggedIn = false, userInfo } = this.props;
    const { admin = false, firstName, soundcasts, courses } = userInfo;

    if (!isLoggedIn) {
      return (
        <NavBar className="nav navbar-nav sm-no-padding">
          <li className="propClone">
            <Link className="inner-link" to="/signin">
              Log In
            </Link>
          </li>
        </NavBar>
      );
    }

    return (
      <NavBar className="nav navbar-nav sm-no-padding">
        <li className="propClone sm-no-border">
          <div className="dropdown">
            <DropdownToggle className="btn dropdown-toggle sm-padding-five" data-toggle="dropdown">
              <div className="text-large sm-title-small">
                {`Hello, ${this.capFirstLetter(firstName)} `}
                <span className="caret" />
              </div>
            </DropdownToggle>
            <ul className="dropdown-menu">
              {soundcasts && (
                <li>
                  <Link to="/mysoundcasts">My Library</Link>
                </li>
              )}
              {admin && (
                <li>
                  <Link to="/dashboard/soundcasts">Admin Dashboard </Link>
                </li>
              )}
              {courses && (
                <li>
                  <Link to="/myprograms">My Courses</Link>
                </li>
              )}
              <li>
                <Link to="/myprofile">My Profile</Link>
              </li>
              {admin && canUserAccessFeature('SOUNDWAVE_VIDEOS') && (
                <li>
                  <Link to="/wave_video">Soundwave Video</Link>
                </li>
              )}
              {!admin && (
                <li>
                  <Link to="/pricing">Create a Publisher Plan </Link>
                </li>
              )}
              <li>
                <a onClick={this.signoutUser}>Log Out</a>
              </li>
            </ul>
          </div>
        </li>
      </NavBar>
    );
  }

  renderCustomIcon() {
    const { showIcon, customIcon = null } = this.props;
    if (showIcon) return null;

    if (isNull(customIcon)) {
      return <div className="dummy-logo" />;
    }

    return customIcon;
  }

  render() {
    const { showIcon, userInfo } = this.props;
    return (
      <header className="leadgen-agency-1" id="header-section1">
        <PartnerBanner userInfo={userInfo} />
        <SoundwiseNavigation className="navbar bg-white tz-header-bg no-margin alt-font shrink-header light-header">
          <div className="navigation-menu padding-two-left padding-two-right">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-10 col-xs-10">
                {showIcon && (
                  <a href={STATIC_HOMEPAGE_URL} title="Soundwise">
                    <img
                      className="sm-padding-two-left logo"
                      alt="Soundwise Logo"
                      src="/images/soundwiselogo.svg"
                    />
                  </a>
                )}
                {this.renderCustomIcon()}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-2 col-xs-2 position-inherit">
                <button
                  data-target="#bs-example-navbar-collapse-1"
                  data-toggle="collapse"
                  className="navbar-toggle collapsed"
                  type="button">
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
                <div
                  id="bs-example-navbar-collapse-1"
                  className="collapse navbar-collapse pull-right font-weight-500">
                  {this.renderLogin()}
                </div>
              </div>
            </div>
          </div>
        </SoundwiseNavigation>
      </header>
    );
  }
}

const SoundwiseNavigation = styled.nav`
  .logo {
    max-height: 50px;

    @media (max-width: 991px) {
      max-height: 40px;
    }
  }

  .dummy-logo {
    width: 50px;
    height: 50px;

    @media (max-width: 991px) {
      max-height: 40px;
      max-width: 40px;
    }
  }

  .nav .dropdown-menu {
    left: auto;
    right: 0;

    @media (max-width: 991px) {
      right: auto;
    }
  }
`;

const NavBar = styled.ul`
  @media (max-width: 991px) {
    border-bottom: 1px solid #eee;
    .dropdown-menu {
      & > li {
        margin: 0px;
        padding: 5px 0px;
      }
    }
  }
`;

const DropdownToggle = styled.div`
  .caret {
    margin-left: 5px;
  }

  @media (max-width: 991px) {
    pointer-events: auto;
  }

  &:active {
    box-shadow: none;
  }
`;

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ signoutUser }, dispatch);
}

const mapStateToProps = state => {
  const { userInfo, isLoggedIn } = state.user;
  return { userInfo, isLoggedIn };
};

const SoundwiseHeader_worouter = connect(mapStateToProps, mapDispatchToProps)(_SoundwiseHeader);

export const SoundwiseHeader = withRouter(SoundwiseHeader_worouter);
